import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getSelectedCookies, getManagerDependingVariables } from ".";
import { putHtmlCodeToDom } from "..";
import { getOtherOptionsFromWindow } from "../../utils";
/**
 * Opt-in and opt-out to a set of cookies for a given data manager like GTM / MTM.
 */

function applyOptInOutManager(_x, _x2, _x3) {
  return _applyOptInOutManager.apply(this, arguments);
}

function _applyOptInOutManager() {
  _applyOptInOutManager = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(type, dataLayer, isManagerOptOut) {
    var _getSelectedCookies, isManagerActive, iterateCookies, _getOtherOptionsFromW, setCookiesViaManager, _getManagerDependingV, useVariableNameCamel, useVariableNamePascal;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            /* onlypro:start */
            _getSelectedCookies = getSelectedCookies(type), isManagerActive = _getSelectedCookies.isManagerActive, iterateCookies = _getSelectedCookies.iterateCookies;
            _getOtherOptionsFromW = getOtherOptionsFromWindow(), setCookiesViaManager = _getOtherOptionsFromW.setCookiesViaManager;
            _getManagerDependingV = getManagerDependingVariables(isManagerActive, setCookiesViaManager), useVariableNameCamel = _getManagerDependingV.useVariableNameCamel, useVariableNamePascal = _getManagerDependingV.useVariableNamePascal; // When there is a manager, let's push all opt-in and opt-out events (parallel)

            if (!dataLayer) {
              _context2.next = 10;
              break;
            }

            // Opt-in events
            iterateCookies(function (group, cookie, isOptIn) {
              var event = cookie["".concat(useVariableNameCamel, "InEventName")];

              if (isOptIn && event) {
                dataLayer.push({
                  event: event
                });
              }
            }); // Wait x seconds

            _context2.next = 7;
            return new Promise(function (r) {
              return setTimeout(r, 1000);
            });

          case 7:
            // Opt-out events
            iterateCookies(function (group, cookie, isOptIn) {
              var event = cookie["".concat(useVariableNameCamel, "OutEventName")];

              if (!isOptIn && event) {
                dataLayer.push({
                  event: event
                });
              }
            });
            _context2.next = 13;
            break;

          case 10:
            if (!(isManagerActive && isManagerOptOut)) {
              _context2.next = 13;
              break;
            }

            _context2.next = 13;
            return iterateCookies( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(group, _ref, isOptIn) {
                var codeDynamics, codeOptIn, rest;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        codeDynamics = _ref.codeDynamics, codeOptIn = _ref.codeOptIn, rest = _objectWithoutProperties(_ref, ["codeDynamics", "codeOptIn"]);

                        if (isOptIn && rest["codeOptInNo".concat(useVariableNamePascal)]) {
                          putHtmlCodeToDom(codeOptIn, codeDynamics);
                        }

                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x4, _x5, _x6) {
                return _ref2.apply(this, arguments);
              };
            }());

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _applyOptInOutManager.apply(this, arguments);
}

export { applyOptInOutManager };